import React from 'react'
import { Route } from 'react-router-dom'
import cx from 'classnames'
import NotifierContainer from '@softwaredev_cegeka/stix-notifier/dist/components/NotifierContainer'
import { PageHeaderContext } from 'src/components/PageHeader/pageHeaderContext'
import SettingsNavbar from 'src/components/SettingsNavbar'
import withTranslations from 'src/HOCs/withTranslations'

import baseStyles from 'src/assets/styles/base.module.scss'

// MFEs listed here are mounted once per top-level path segment (e.g. /security vs /ccf)
// so their dynamic basePath is recalculated on remount. Add a component here if it needs
// the same per-segment remount behaviour; other MFEs stay mounted across sibling
// pages/tabs so state (e.g. selected subsidiary) is preserved.
const DYNAMIC_BASE_PATH_COMPONENTS = new Set(['./mfes/CSOD'])

export function getContentRouteKey(route) {
    if (DYNAMIC_BASE_PATH_COMPONENTS.has(route.component)) {
        const topSegment = route.path.split('/').find(Boolean)
        return `${route.component}-${topSegment}`
    }
    return route.component
}

// Wrap router for passing props to child components.
export default class ContentRoute extends React.Component {
    static contextType = PageHeaderContext // Set the context type
    LazyComponent = this.createLazyComponent()

    createLazyComponent() {
        const LazyComponent = React.lazy(() => {
            const importPromise = import(
                /* webpackExclude: /(\.test\.js$|__testTools__|\.test\.json$|\/server\/)/ */
                `src/routes/${this.props.component.replace(/^\.\//, '')}`
            )
            importPromise
                .then(() => localStorage.setItem('import-fail-count', '0'))
                .catch(ex => {
                    console.error(ex)
                    const failCount =
                        parseInt(
                            localStorage.getItem('import-fail-count'),
                            10
                        ) || 0
                    if (failCount > 2) {
                        throw ex
                    }
                    // Reload the current page when a chunk fails to load.
                    // This can happen when a new build was deployed and certain chunks don't exist anymore or were renamed, resulting in an import error.
                    localStorage.setItem('import-fail-count', failCount + 1)
                    window.location.reload()
                })
            return importPromise
        })

        return withTranslations(
            `route.${this.props.name}`,
            'route'
        )(LazyComponent)
    }

    render() {
        const { path, title, name, options } = this.props
        const { LazyComponent } = this
        return (
            <Route
                path={path}
                exact
                render={routeProps => {
                    return (
                        <div
                            className={cx({
                                [baseStyles.contentRoute]: name !== 'not-found',
                            })}
                        >
                            <NotifierContainer
                                position={'fixed'}
                                defaults={{
                                    autohide: true,
                                    delay: 5000,
                                    animation: true,
                                }}
                            />
                            {options?.showSettingsBar && <SettingsNavbar />}
                            <LazyComponent
                                key={this.props.component}
                                path={path}
                                routeName={name}
                                title={title}
                                {...routeProps}
                            />
                        </div>
                    )
                }}
            />
        )
    }
}
